<template>
  <div class="salecost-page">
	<Header></Header> <!-- 头部 -->
	<div class="content">
		<div class="search">
			<van-field
				class="search_show"
				id="js-saleCostInternalName"
				v-model="saleCostInternalName"
				required
				label="内部料号:"
				placeholder="请输入或选择完整内部物料"
				@input="onInputShow('js-saleCostInternalName')"
			/>
			<van-field
				v-model="saleCostName"
				label="原厂料号:"
				placeholder="请输入或选择完整原厂物料"
			/>
			<van-field
				class="search_show"
				id="js-saleCostProductCategoryName"
				v-model="saleCostProductCategoryName"
				label="内部产线:"
				placeholder="请输入或选择完整内部产线"
				@input="onInputShow('js-saleCostProductCategoryName')"
			/>
			<van-field
			    class="search_show"
				v-model="pageSaleCostCustomerName"
				id="js-pageSaleCostCustomerName"
				label="客户名称:"
				placeholder="请输入或选择完整客户编码"
				@input="onInputShow('js-pageSaleCostCustomerName')"
			/>
			<van-field
			    class="search_show"
				v-model="saleCostCustomerCode"
				id="js-saleCostCustomerCode"
				label="客户编号:"
				placeholder="请输入或选择完整客户编码"
				@input="onInputShow('js-saleCostCustomerCode')"
			/>
			<van-field
				v-model="saleCostEndCustomerName"
				label="终端客户:"
				placeholder="请输入或选择完整终端客户"
			/>
			<van-field
				v-model="saleCostProjectName"
				label="项目名称:"
				placeholder="请输入或选择完整项目名称"
			/>
				<van-button type="primary" @click="onSearch()">搜索</van-button>
				<!-- <van-button loading type="primary">搜索</van-button> -->
		</div>

		<div class="tbl">
			<van-grid :column-num="1" class="tbl-th">
			  <van-grid-item text="SALES COST" />
			</van-grid>
			<van-grid class="tbl-tr" :column-num="5" >
			  <van-grid-item text="币种" />
			  <van-grid-item text="销售成本" />
			  <van-grid-item text="最低卖价" />
			  <van-grid-item text="生效日期" />
			  <van-grid-item text="失效日期" />
			</van-grid>
			<van-grid class="tbl-td" :column-num="5" v-for="item in joa_list_sales">
			  <van-grid-item :text="item.Currency" />
			  <van-grid-item class="price" :text="item.SalesCosUntaxed" />
			  <van-grid-item class="price" :text="item.MinGrossRate" />
			  <van-grid-item :text="item.StartTime.substring(0,10)" />
			  <van-grid-item :text="item.EndTime.substring(0,10)" />
			</van-grid>
		</div>
		<div class="tbl">
			<van-grid class="tbl-th" :column-num="1">
			  <van-grid-item text="RFQ-最近一次核准含税卖价" />
			</van-grid>
			<van-grid :column-num="5" class="tbl-tr">
			  <van-grid-item text="币种" />
			  <van-grid-item text="核准卖价" />
			  <van-grid-item text="客户账期" />
			  <van-grid-item text="生效日期" style="width: 30%;" />
			  <van-grid-item text="失效日期" style="width: 30%;" />
			</van-grid>
			<van-grid class="tbl-td" :column-num="5" v-for="(item,index) in joa_list_sales" v-if="(item.RFQCurrency && index==0)">
			  <van-grid-item :text="item.RFQCurrency" />
			  <van-grid-item class="price" :text="item.ApprovedResale" />
			  <van-grid-item :text="item.RFQZtermCode" />
			  <van-grid-item :text="item.RFQEffectDate.substring(0,10)" />
			  <van-grid-item :text="item.RFQExpireDate.substring(0,10)" />
			</van-grid>
		</div>
		<div class="tbl">
			<van-grid class="tbl-th" :column-num="1">
			  <van-grid-item text="SO-最近一次订单含税卖价" />
			</van-grid>
			<van-grid class="tbl-tr" :column-num="5">
			  <van-grid-item text="币种" />
			  <van-grid-item text="订单卖价" />
			  <van-grid-item text="客户账期" />
			  <van-grid-item text="订单日期" />
			  <van-grid-item text="需求日期" />
			</van-grid>
			<van-grid class="tbl-td" :column-num="5" v-for="(item,index) in joa_list_sales" v-if="(item.OrderCurrency && index==0)">
			  <van-grid-item :text="item.OrderCurrency" />
			  <van-grid-item class="price" :text="item.OrderApprovedResale" />
			  <van-grid-item :text="item.OrderZtermCode" />
			  <van-grid-item :text="item.OrderDate.substring(0,10)" />
			  <van-grid-item :text="item.CRD.substring(0,10)" />
			</van-grid>
		</div>
		<Footer></Footer> <!-- 尾部 -->
	</div>
  </div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  data() {
    return {
	    value: 0,
		switch1: false,
		switch2: false,
		option: [
		  { text: '全部商品', value: 0 },
		  { text: '新款商品', value: 1 },
		  { text: '活动商品', value: 2 }
		],
	  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN')),
	  saleCostInternalName: "",
	  saleCostName: "",
	  saleCostProductCategoryName: "",
	  saleCostProductCategoryID: 0,
	  pageSaleCostCustomerName: "",
	  pageSaleCostCustomerID: 0,
	  saleCostCustomerCode: "",
	  saleCostEndCustomerName: "",
	  saleCostProjectName: "",
	  joa_list_sales: [],
	  joa_list_rfq: [],
	  joa_list_so: []
	};
  },
  mounted(){
	this.watermark.set(this.ADMIN.USER_NAME+"_"+this.ADMIN.USER_CODE); //水印
  },
  methods: {
	    onInputHide: function () {
			$("ul.input_show").hide();
		},
	    onInputShow: function (id) {
			var post_obj = new Object();
			if(id=="js-pageSaleCostCustomerName"){ //客户名称
				post_obj.apiType = "DataApi";
				post_obj.fieldName = "Name";
				post_obj.moduleName = "客户主数据";
				post_obj.q =$("#"+id).val();
			}else if(id=="js-saleCostCustomerCode"){ //客户编号
				post_obj.apiType = "DataApi";
				post_obj.fieldName = "KunnrCode";
				post_obj.moduleName = "客户主数据";
				post_obj.q =$("#"+id).val();
			}else{
				post_obj.apiType = "DataApi";
				post_obj.fieldName = "InternalName";
				post_obj.moduleName = "物料信息";
				post_obj.of = "Crm_Srm_ProductCategoryId";
				post_obj.q =$("#"+id).val();
			}
			if($("#"+id).val()!=""){
				axios.post(this.CoreNew.OA_API_IP+"joa-crm/crm/mobile/IntelliPrompt/",post_obj,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
				//axios.post(this.CoreNew.OA_API_IP+"joa-crm/crm/mobile/IntelliPrompt",post_obj).then(function (response) {
					var $rs=response.data;var str_html="";
					if($rs.flag==true){
						var $list=$rs.data;var _str_html;
						if($rs.data!=null){
							for (var i = 0; i < $list.length; i++) {
								str_html +="<li data-id='"+$list[i].Id+"' data-val='"+$list[i].Name+"' data-InternalName='"+$list[i].f_Name+"' data-Srm-ProductCategoryName='"+$list[i].Crm_Srm_ProductCategoryName+"' data-Srm-ProductCategoryId='"+$list[i].Crm_Srm_ProductCategoryId+"'>"+$list[i].Name.replace(this.saleCostInternalName.toUpperCase(), "<span>"+this.saleCostInternalName.toUpperCase()+"</span>")+"</li>";
							}
							$("#"+id).parent().find("ul.input_show").remove();
							$("#"+id).parent().append('<ul class="input_show">'+str_html+'</ul>');
							$("#"+id).parent().find("ul.input_show").show();
							var self = this;
							$("#"+id).parent().find("ul.input_show li").click(function(){
								if(id=="js-saleCostInternalName"){
									self.saleCostInternalName=$(this).attr("data-val");
									self.saleCostName=$(this).attr("data-InternalName");
								}
								if(id=="js-saleCostInternalName" || id=="js-saleCostProductCategoryName"){
									self.saleCostProductCategoryName=$(this).attr("data-Srm-ProductCategoryName");
									self.saleCostProductCategoryID=$(this).attr("data-Srm-ProductCategoryId");
								}else if(id=="js-pageSaleCostCustomerName"){ //客户名称
									self.pageSaleCostCustomerName=$(this).attr("data-val");
									self.pageSaleCostCustomerID=$(this).attr("data-id");
								}else if(id=="js-saleCostCustomerCode"){ //客户编号
									self.saleCostCustomerCode=$(this).attr("data-val");
								}
								$("#"+id).parent().find("ul.input_show").hide();
							})
						}
					}else{
						$("#"+id).parent().find("ul.input_show").html("");
						$("#"+id).parent().find("ul.input_show").hide();
					}
				}.bind(this)).catch(function (error) {
					//alert("请求--SaleCost--失败"+error);
					this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--SaleCost--失败"+error);//记录错误
					console.log("请求--SaleCost--失败"+error);
				});
			}else{
				console.log("延时");
				$("#"+id).parent().find("ul.input_show").hide();
			}
	    },
		onSearch: function () {
			// $(".search_show").hide();
			if(this.saleCostInternalName== ''){
				this.$toast('内部物料不能为空');
			}else{
				$("#loading").show();
				//$(".search button").html('<div class="van-loading van-loading--circular van-button__loading"><span class="van-loading__spinner van-loading__spinner--circular" style="color: currentcolor; width: 20px; height: 20px;"><svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg></span></div>');
				let post_data = new FormData();
				post_data.append('empUserName',JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
				post_data.append('Crm_Pm_ProductInfoName',this.saleCostInternalName);
				if(this.saleCostName!= ''){post_data.append('internalName',this.saleCostName);}
				if(this.saleCostProductCategoryName!= ''){post_data.append('Crm_Srm_ProductCategoryId',this.saleCostProductCategoryID);}
				if(this.pageSaleCostCustomerName!= ''){
					if(this.pageSaleCostCustomerID!= ''){
						post_data.append('Crm_Cm_CustomerMasterId',this.pageSaleCostCustomerID);
					}else{
						post_data.append('Crm_Cm_CustomerMasterId',this.pageSaleCostCustomerName);
					}
				}
				if(this.saleCostCustomerCode!= ''){post_data.append('customerCode',this.saleCostCustomerCode);}
				if(this.saleCostEndCustomerName!= ''){post_data.append('endCustomer',this.saleCostEndCustomerName);}
				if(this.saleCostProjectName!= ''){post_data.append('projectName',this.saleCostProjectName);}
				axios.post(this.CoreNew.OA_API_IP+"joa-crm/crm/mobile/SalesCostInquiry/",post_data,{
					headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
				}).then(function (response) {
				//axios.post(this.CoreNew.OA_API_IP+"joa-crm/crm/mobile/SalesCostInquiry",post_data).then(function (response) {
					var $rs=response.data;
					if($rs.flag==true){
						//var $list=$rs.data;
						//this.joa_list_sales=this.joa_list_sales.concat($list);
						var $list=JSON.parse($rs.data);
						this.joa_list_sales=$list;
						//this.joa_list_rfq=$list[0];
						//this.joa_list_so=$list[0];
					}
					$("#loading").hide();
					//$(".search button").html('<span class="van-button__text">搜索</span>');
				}.bind(this))
				.catch(function (error) {
				   $("#loading").hide();
				   //$(".search button").html('<span class="van-button__text">搜索</span>');
				   //alert("请求--产品搜索--失败"+error);
				   this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--产品搜索--失败"+error);//记录错误
				   console.log("请求--产品搜索--失败"+error);
				});
			}
		}
    }
};
</script>
